export type WantedMonthlyMemoPanelPosition = {
  readonly x: number;
  readonly y: number;
};

const STORAGE_KEY_PREFIX = "roster-wanted:monthly-memo-panel-position";
const OPEN_STATE_STORAGE_KEY_PREFIX = "roster-wanted:monthly-memo-panel-open";

function getStorageKey(nurseId: string) {
  return `${STORAGE_KEY_PREFIX}:${nurseId}`;
}

function getOpenStateStorageKey(nurseId: string) {
  return `${OPEN_STATE_STORAGE_KEY_PREFIX}:${nurseId}`;
}

function isPanelPosition(
  value: unknown
): value is WantedMonthlyMemoPanelPosition {
  return (
    typeof value === "object" &&
    value !== null &&
    "x" in value &&
    "y" in value &&
    typeof value.x === "number" &&
    Number.isFinite(value.x) &&
    typeof value.y === "number" &&
    Number.isFinite(value.y)
  );
}

export function loadWantedMonthlyMemoPanelPosition(
  nurseId?: string
): WantedMonthlyMemoPanelPosition | null {
  if (!nurseId) return null;

  try {
    const storedValue = window.localStorage.getItem(getStorageKey(nurseId));
    if (!storedValue) return null;

    const position: unknown = JSON.parse(storedValue);
    return isPanelPosition(position) ? position : null;
  } catch {
    return null;
  }
}

export function saveWantedMonthlyMemoPanelPosition(
  nurseId: string | undefined,
  position: WantedMonthlyMemoPanelPosition
) {
  if (!nurseId) return;

  window.localStorage.setItem(getStorageKey(nurseId), JSON.stringify(position));
}

export function loadWantedMonthlyMemoPanelOpen(nurseId?: string): boolean {
  if (!nurseId) return false;

  return window.localStorage.getItem(getOpenStateStorageKey(nurseId)) === "true";
}

export function saveWantedMonthlyMemoPanelOpen(
  nurseId: string | undefined,
  isOpen: boolean
) {
  if (!nurseId) return;

  window.localStorage.setItem(getOpenStateStorageKey(nurseId), String(isOpen));
}
